import ContentCopy from '@mui/icons-material/ContentCopy';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { alpha } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';
import { NAVY, RADIUS_ITEM, SURFACE_CONTAINER_LOW } from 'styles/tokens';

import type { TurnToolCall } from '../types';

const prettyArgs = (raw: string): string => {
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
};

interface ToolCallCardProps {
  toolCall: TurnToolCall;
}

/** Read-only render of a tool call: function name + pretty-printed JSON arguments. */
const ToolCallCard: FC<ToolCallCardProps> = ({ toolCall }) => {
  const args = prettyArgs(toolCall.arguments);

  return (
    <Box
      sx={{
        bgcolor: SURFACE_CONTAINER_LOW,
        borderRadius: RADIUS_ITEM,
        p: 1,
        mt: 0.75,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
        <Typography
          sx={{
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
            fontSize: 12,
            fontWeight: 600,
            color: NAVY,
          }}
        >
          🛠 {toolCall.name || '(sin nombre)'}
        </Typography>
        <Tooltip title="Copiar argumentos">
          <IconButton
            size="small"
            onClick={() => {
              navigator.clipboard.writeText(args).catch(() => {});
            }}
            sx={{ color: alpha(NAVY, 0.5) }}
          >
            <ContentCopy sx={{ fontSize: 14 }} />
          </IconButton>
        </Tooltip>
      </Box>
      <Typography
        component="pre"
        sx={{
          m: 0,
          mt: 0.5,
          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
          fontSize: 11.5,
          lineHeight: 1.45,
          color: alpha(NAVY, 0.85),
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        }}
      >
        {args}
      </Typography>
    </Box>
  );
};

export default ToolCallCard;
